module.exports = __webpack_public_path__ + "media/images/bannerImage10-a79eecfa2a7450fe9b7c846d77d0d3ed.jpg";